<div
  [ngStyle]="{ height: height + 'px' }"
  class="w-full flex items-center px-5 max-w-screen-xl mx-auto"
>
  <svg
    (click)="burgerClick.emit()"
    class="size-5 icon-bytesize text-white"
    role="button"
  >
    <use
      *ngIf="!openSidenav"
      attr.xlink:href="{{ '#burger-menu' | bytesizeIcon }}"
    ></use>
    <use
      *ngIf="openSidenav"
      attr.xlink:href="{{ '#i-close' | bytesizeIcon }}"
      stroke-width="3px"
    ></use>
  </svg>

  <a
    [href]="homeUrl"
    class="select-none"
  >
    <img
      alt="logo cimb"
      class="h-6 ml-5 md:ml-0 md:absolute md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2"
      src="assets/core/logo.svg"
    />
  </a>
</div>
